import React from 'react'
import List from "../assets/data/List"
import Card1 from '../components/Card1'
import { useNavigate } from 'react-router-dom'

const Home = () => {
  const navigate=useNavigate()
  return (
    <div className='w-full lg:h-screen  py-12 lg:py-20 bg-blue-300'>

        <div className='w-11/12 mx-auto flex flex-col gap-y-8  '>

            <div className=''>
                <div className='text-2xl lg:text-3xl font-semibold text-left'>Book an appointment for an in-clinic consultation</div>
                <div className='text-sm text-left'>Find experienced doctors across all specialities</div>
            </div>


            <div className='grid w-full grid-cols-1  content-center md:grid-cols-2 lg:grid-cols-3 gap-8 mt-5 '>
            {
              List.map((data,index)=>{
                return (
                  <Card1  key={index} data={data} navigate={navigate} />
                )
              })
            }

            </div>
        </div>
    </div>
  )
}

export default Home